import ImageIcon from '@mui/icons-material/Image';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import VideoFileIcon from '@mui/icons-material/VideoFile';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { FileTypes } from '../../utils/constants';

const PALETTE = {
    [FileTypes.VIDEO]: { key: 'secondary', Icon: VideoFileIcon },
    [FileTypes.TEXT]: { key: 'info', Icon: TextSnippetIcon },
    [FileTypes.BOOK]: { key: 'success', Icon: AutoStoriesIcon },
    [FileTypes.POST]: { key: 'primary', Icon: ImageIcon },
    [FileTypes.AUDIO]: { key: 'warning', Icon: AudiotrackIcon },
};

/** The tinted square file-type icon used in the file and task lists. */
const FileTypeIcon = ({ type }) => {
    const { key, Icon } = PALETTE[type] || PALETTE[FileTypes.AUDIO];
    return (
        <Box
            sx={{
                width: 28,
                height: 28,
                flexShrink: 0,
                borderRadius: '8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid',
                borderColor: (theme) => alpha(theme.palette[key].main, 0.35),
                backgroundColor: (theme) => alpha(theme.palette[key].main, 0.12),
            }}
        >
            <Icon sx={{ fontSize: '1.1rem', color: `${key}.main` }} />
        </Box>
    );
};

/** Task content types (VIDEO/TEXT/BOOK/POST) as file list types. */
export const fileTypeForContent = (contentType) =>
    ({ VIDEO: FileTypes.VIDEO, TEXT: FileTypes.TEXT, BOOK: FileTypes.BOOK, POST: FileTypes.POST, AUDIO: FileTypes.AUDIO })[contentType] ||
    FileTypes.VIDEO;

export default FileTypeIcon;
